import {HTMLAttributes} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import getCurrentYear from 'utils/date';
import {footer, footerLink} from './styles.module.css';

const FooterBasic = ({className, ...rest}: HTMLAttributes<HTMLElement>) => {
    const {i18n, t} = useTranslation();

    return (
        <footer className={clsx(footer, 'flex p-4')} {...rest}>
            <div className="flex flex-1">
                <div className="flex items-center gap-2">
                    <a
                        className={footerLink}
                        href={`https://www.makeleaps.com/${i18n.language}/about-us/`}
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t('footer.links.about')}
                    </a>
                    <a
                        className={footerLink}
                        href="https://help.makeleaps.jp/ja/"
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t('footer.links.helpCenter')}
                    </a>
                    <a
                        className={footerLink}
                        href={`https://www.makeleaps.com/${i18n.language}/q-a/`}
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t('footer.links.qAndA')}
                    </a>
                </div>
                <div className="grid flex-1 content-center pl-5 text-right text-white">
                    © {getCurrentYear()} MakeLeaps
                </div>
            </div>
        </footer>
    );
};
export default FooterBasic;
